import {ValueDefinition} from '@/model/types';
import {API, Endpoints} from '../api';

export function getDefinitions(ids: string[]) {
  return API.get<ValueDefinition[]>(Endpoints.definitions.multiple + `?id=${ids.join(',')}`);
}
